import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./ReturnOrder.css";
import RONavigation from "../../components/ReturnOrderComp/RONavigate";
import ROContent from "../../components/ReturnOrderComp/ROContent";

const ReturnOrder = () => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <Header setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <RONavigation />
        </div>
        <div className="content-index">
          <ROContent />
        </div>
      </div>
    </div>
  );
};

export default ReturnOrder;
